/* ============================================================
   EUTEYIA - Fix boutons express du panier (Apple Pay / Shop Pay)
   Objectif : UN seul wallet a cote de "Commander", pile sur sa
   moitie, jamais de "flop" (les 3 wallets qui reviennent) meme
   en nav privee.
   ⚠️ NE JAMAIS forcer width/display sur les web components en CSS
      (shopify-apple-pay-button / shop-pay-wallet-button / -cart) :
      ca a deja CRASHE Safari. On filtre wallet-configs a la source
      + on masque en JS. C'est tout.
   ============================================================ */
(function(){
  /* Detection Apple Pay RE-EVALUEE a chaque passe (en nav privee,
     Safari peut l'initialiser en retard -> on ne fige plus au load) */
  function isApple(){
    try{return !!(window.ApplePaySession && window.ApplePaySession.canMakePayments && window.ApplePaySession.canMakePayments());}catch(e){return false;}
  }
  function keepName(w,wallet){var n=String(w&&w.name||'');return wallet==='apple'?n.indexOf('apple')>-1:n==='shop_pay';}
  function filterCfg(raw,wallet){try{var a=JSON.parse(raw);if(!Array.isArray(a))return null;return JSON.stringify(a.filter(function(w){return keepName(w,wallet);}));}catch(e){return null;}}

  function hideExtras(root,apple){
    if(!root)return;
    var pp=root.querySelectorAll('shopify-paypal-button');for(var i=0;i<pp.length;i++)pp[i].style.display='none';
    var ifr=root.querySelectorAll('iframe');for(var k=0;k<ifr.length;k++){var t=((ifr[k].getAttribute('title')||'')+' '+(ifr[k].getAttribute('src')||'')).toLowerCase();if(t.indexOf('paypal')>-1)ifr[k].style.display='none';}
    var ap=root.querySelectorAll('shopify-apple-pay-button');for(var m=0;m<ap.length;m++)ap[m].style.display=apple?'':'none';
    var sp=root.querySelectorAll('shop-pay-wallet-button');for(var q=0;q<sp.length;q++)sp[q].style.display=apple?'none':'';
  }
  function collapse(el){try{el.style.setProperty('height','auto','important');el.style.setProperty('min-height','0','important');var dc=el.closest('.dynamic-checkout__content');if(dc){dc.style.setProperty('height','auto','important');dc.style.setProperty('min-height','0','important');}var exp=el.closest('.eut-ctas__express');if(exp){exp.style.setProperty('height','auto','important');exp.style.setProperty('min-height','0','important');}}catch(e){}}

  function run(){
    var apple=isApple();
    var wallet=apple?'apple':'shop_pay';
    var els=document.querySelectorAll('.eut-ctas__express shopify-accelerated-checkout-cart');
    for(var i=0;i<els.length;i++){var el=els[i];
      /* garde la config d'ORIGINE (tous les wallets) pour pouvoir re-filtrer
         a CHAQUE re-hydratation (le bug d'avant : verrou __eutA -> jamais re-filtre
         -> en prive le composant remettait les 3 wallets = flop) */
      if(!el.__eutRaw){var r0=el.getAttribute('wallet-configs');if(r0)el.__eutRaw=r0;}
      if(el.__eutRaw){
        var w=wallet,n=filterCfg(el.__eutRaw,w);
        if(n==='[]'){w='shop_pay';n=filterCfg(el.__eutRaw,'shop_pay');}
        var cur=el.getAttribute('wallet-configs');
        if(n!==null && n!==cur){el.setAttribute('wallet-configs',n);}
        el.__eutWallet=w;
      }
      hideExtras(el.closest('.eut-ctas__express')||el, el.__eutWallet==='apple');
      collapse(el);
    }
  }

  /* Observer SUR : n'ecoute QUE childList (pas d'attributs/styles -> pas de boucle)
     + kill-switch + scans temporises pour les rendus tardifs (nav privee lente) */
  var scheduled=false,calls=0,t0=Date.now(),obs=null;
  function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(function(){scheduled=false;
    if(Date.now()-t0>2000){t0=Date.now();calls=0;}calls++;if(calls>200){if(obs){try{obs.disconnect();}catch(e){}}return;}
    run();});}
  run();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);
  document.addEventListener('cart:refresh',function(){[50,300,700,1500,3000].forEach(function(m){setTimeout(run,m);});});
  [0,10,25,50,90,150,250,400,650,1000,1600,2500,4000,6000,8000].forEach(function(ms){setTimeout(run,ms);});
  try{var tgt=document.querySelector('.cart-drawer,cart-drawer,#Cart-Drawer,.side-panel')||document.body;obs=new MutationObserver(schedule);obs.observe(tgt,{childList:true,subtree:true});}catch(e){}
})();
